if ("__APP_START_TIME__" in window) {
    const now = new Date();
    const loadTime = now.getTime() - window.__APP_START_TIME__.getTime();
    log("Start loading main.tsx: ", loadTime);
}

import { QueryClientProvider } from "@tanstack/react-query";
import App from "components/app/app";
import { getInitialCrashReportingSetting } from "components/app/app-helper";
import config from "config/app.config";
import { ErrorProvider } from "context/error-provider";
import { clickTrackingService } from "logger/click-tracking";
import { trackPageView } from "logger/insights";
import { log, trackEvent } from "logger/logger";
import { getAppMode } from "types/app-mode";
import queryClient from "query-client";
import rg4js from "raygun4js";
import React from "react";
import ReactDOM from "react-dom/client";
import { getSearchParams } from "search-params";
import "utils/load-script";
import { loadFontStylesheet } from "utils/load-font-stylesheet";
import { listenForFontData } from "utils/listen-for-font-data";
import { guardTranslatedDom } from "utils/guard-translated-dom";

guardTranslatedDom();

// Inject font stylesheet early so fonts start downloading before React renders
loadFontStylesheet();

// Listen for font data sent from the SDK via postMessage (cross-origin font loading)
listenForFontData();

const { system } = getSearchParams();

rg4js("apiKey", import.meta.env.VITE_RAYGUN_API_KEY);
rg4js("enableCrashReporting", getInitialCrashReportingSetting());
rg4js("withTags", [`system:${system}`, String(config.environment)]);
rg4js("options", {
    excludedHostnames: ["localhost"],
    ignoreAjaxError: true,
    ignore3rdPartyErrors: true,
});

trackPageView("Booking", window.location.pathname);
trackEvent("AppMode", { mode: getAppMode() });

// Initialize click tracking
clickTrackingService.initialize();

if ("__APP_START_TIME__" in window) {
    const now = new Date();
    const loadTime = now.getTime() - window.__APP_START_TIME__.getTime();
    log("Before React Render: ", loadTime);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ErrorProvider>
                <App />
            </ErrorProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
